var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var PositionController = /** @class */ (function () {
    function PositionController() {
    }
    /*****************************************************************************************************
        * Is using route "api/position/{groupid}" and http method "GET" to call the back-end.
    
        * @param {string} groupid
        * @returns {string[]}
    ******************************************************************************************************/
    PositionController.Get = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/position/{groupid}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return PositionController;
}());
export { PositionController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=PositionController.js.map